<template>
  <div class="wabident-color-picker">
    <compact-picker :value="value" @input="updateValue" :palette="palette">
    </compact-picker>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      default_palette: [
        "#F06292",
        "#EDC0C1",
        "#BA68C8",
        "#9575CD",
        "#7986CB",
        "#4FC3F7",
        "#4DD0E1",
        "#4DB6AC",
        "#C1DBDF",
        "#81C784",
        "#AED581",
        "#DCE775",
        "#FFF176",
        "#FFB74D",
        "#FF8A65",
        "#A1887F",
        "#ECE1CC",
        "#D5D2C9",
        "#D8B46C",
      ],
    };
  },
  computed: {
    palette() {
      if (!this.clinic_config || !this.clinic_config.clinic_extra_colors) {
        return this.default_palette;
      }

      const colors = this.clinic_config.clinic_extra_colors;
      let extra_colors = [];
      for (const i in colors) {
        extra_colors.push(colors[i]);
      }

      return this.default_palette.concat(extra_colors);
    },
    ...mapGetters(['clinic_config'])
  },
  methods: {
    updateValue(val) {
      this.$emit("input", val);
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss"></style>
